import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Footer from "../components/footer/Footer";
import "./Dashboard.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import UploadPage from "./UploadPage";
import backgroundImage from '../assets/backgorund/home2.jpg';


const Dashboard = () => {
  const navigate = useNavigate();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [form, setForm] = useState({
    username: "",
    emailid: "",
    password: "",
    confirmPassword: ""
  });

  const apiBase = process.env.REACT_APP_API_BASE_URL;

  const sections = [
    { name: "About", key: "about", icon: "fa-info-circle" },
    { name: "Gallery", key: "gallery", icon: "fa-images" },
    { name: "Documents", key: "documents", icon: "fa-file-alt" },
    { name: "Awards", key: "awards", icon: "fa-trophy" },
    { name: "Friends", key: "friends", icon: "fa-user-friends" },
    { name: "Update Profile", key: "profile", icon: "fa-user-edit" },
    { name: "Logout", key: "logout", icon: "fa-sign-out-alt" }
  ];

  const [refreshKey, setRefreshKey] = useState(0);

  const handleSectionClick = (sectionKey) => {
  if (sectionKey === "logout") {
    handleLogout();
    return;
  }
  if (sectionKey === "profile") {
    handleOpenModal();
    return;
  }
  setActiveSection(sectionKey);
  setRefreshKey(prev => prev + 1); // Add this line
  window.history.pushState(null, "", `/admin/${sectionKey}`);
};

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const handleOpenModal = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${apiBase}/user/profile`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setForm({
        username: res.data.username,
        emailid: res.data.emailid,
        password: "",
        confirmPassword: ""
      });
      setShowProfileModal(true);
    } catch (err) {
      console.error("Failed to fetch profile:", err);
      alert("Could not load profile.");
    }
  };

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSaveProfile = async () => {
    if (form.password !== form.confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiBase}/user/update-profile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          username: form.username,
          emailid: form.emailid,
          password: form.password
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to update profile.");
      }

      alert("Profile updated successfully!");
      setShowProfileModal(false);
    } catch (error) {
      console.error("Error:", error.message);
      alert(error.message);
    }
  };

  return (
    <div className="dashboard-container" >
      {/* Main Content Area */}
      <div className="dashboard-content">
        {/* Left Sidebar - Now includes all navigation */}
        <div className="dashboard-sidebar">
          <div className="sidebar-header">
  <div className="logo-container" 
    style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80px',
    height: '80px',
    backgroundColor: 'white',
    borderRadius: '50%', 
    margin: '0 auto 1rem auto', 
    padding: '10px' 
  }}>
    <img 
      src="/assets/logo.png" 
      alt="Company Logo" 
      style={{ 
        width: '50px',
        height: 'auto'
      }}
    />
  </div>
  <h3 
  style={{ 
    textAlign: 'center',
    cursor: 'pointer', // Indicates clickability
  }}
  onClick={() => navigate('/admin/dashboard')}
>
  Admin Dashboard
</h3>
</div>
          {sections.map((section) => (
            <button
              key={section.key}
              onClick={() => handleSectionClick(section.key)}
              className={`sidebar-button ${
                activeSection === section.key ? 'active' : ''
              } ${
                section.key === "logout" ? 'logout-button' : ''
              }`}
            >
              <i className={`fas ${section.icon}`}></i>
              <span>{section.name}</span>
            </button>
          ))}
        </div>

        {/* Main Content */}
        <div className="dashboard-main" style={{backgroundImage: `url(${backgroundImage})` }}>
          {activeSection && activeSection !== "profile" && activeSection !== "logout" ? (
            <UploadPage section={activeSection} key={refreshKey} />
          ) : (
            !showProfileModal && (
              <div className="dashboard-welcome" >

                <img 
                    src="/assets/logo.png" 
                    alt="Company Logo" 
                    className="welcome-logo"
                    style={{ width: '200px', marginBottom: '1rem' }}
                  />

                <h2>Welcome to Admin Dashboard</h2>
                <p>Select a section from the sidebar to get started</p>
              </div>
            )
          )}
        </div>
      </div>

      {/* Profile Modal */}
      {showProfileModal && (
        <div className="modal-backdrop">
          <div className="modal">
            <h2>Update Profile</h2>
            <input
              name="username"
              placeholder="Username"
              value={form.username}
              onChange={handleInputChange}
              required
            />
            <input
              name="emailid"
              placeholder="Email"
              type="email"
              value={form.emailid}
              onChange={handleInputChange}
              required
            />
            
            {/* Password field with eye icon */}
            <div style={{ position: 'relative' }}>
              <input
                name="password"
                placeholder="New Password"
                type={showPassword ? "text" : "password"}
                value={form.password}
                onChange={handleInputChange}
                required
              />
              <i
                className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer'
                }}
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>

            {/* Confirm Password field with eye icon */}
            <div style={{ position: 'relative' }}>
              <input
                name="confirmPassword"
                placeholder="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                value={form.confirmPassword}
                onChange={handleInputChange}
                required
              />
              <i
                className={`fas ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer'
                }}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              />
            </div>

            <div className="modal-buttons">
              <button onClick={handleSaveProfile}>Save</button>
              <button onClick={() => setShowProfileModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Dashboard;